import React from "react"
import { useSearchParams } from "react-router-dom"
import { ProfessorLayoutUI } from "./ProfessorLayout.ui"

export const ProfessorLayoutView = () => {
  const [searchParams] = useSearchParams()

  // Si el query param authOrigin es "parent", ocultamos el header
  const showHeader = searchParams.get("authOrigin") !== "parent"

  return <ProfessorLayoutUI showHeader={showHeader} />
}
